var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrandDefaultIcon48X48 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v48H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#brand_default_icon_48x48_svg__a)",
  fill: "#BFC6CE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.665 25.666c-.753 0-1.505.482-1.91.982-1.197 1.386-2.799 2.483-4.922 2.483-3.3 0-5.808-2.675-5.808-5.736 0-3.06 2.508-5.736 5.808-5.736 2.104 0 3.706 1.097 4.921 2.483.406.5 1.158.982 1.91.982 1.39 0 2.336-1.04 2.336-2.195 0-.443-.096-.943-.386-1.367C32.723 14.79 29.674 13 25.834 13c-5.906 0-10.518 4.562-10.518 10.395 0 5.833 4.612 10.395 10.517 10.395 3.802 0 6.87-1.771 8.781-4.562.29-.424.386-.905.386-1.367 0-1.136-.965-2.195-2.335-2.195ZM15.316 36.1a2.313 2.313 0 0 0 2.316-2.31 2.313 2.313 0 0 0-2.316-2.31A2.313 2.313 0 0 0 13 33.79a2.313 2.313 0 0 0 2.316 2.31Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "brand_default_icon_48x48_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(13 13)",
  d: "M0 0h22v23.1H0z"
})))));
export default SvgBrandDefaultIcon48X48;